import { useLayoutEffect, useState, useCallback, RefObject } from "react"
import ResizeObserver from "resize-observer-polyfill"

export interface ResizeObserverEntry {
  target: HTMLElement
  contentRect: DOMRectReadOnly
}

export const usePrevSpeakerStreamsResizeObserver = (
  ref: RefObject<HTMLElement>,
  onResize?: (entry: DOMRectReadOnly) => void
) => {
  const [widthPrevSpeaker, setWidthPrevSpeaker] = useState<number>(0)
  const [heightPrevSpeaker, setHeightPrevSpeaker] = useState<number>(0)

  const handleResize = useCallback(
    (entries: ResizeObserverEntry[]) => {
      if (!Array.isArray(entries)) {
        return
      }

      const entry = entries[0] ?? null
      setWidthPrevSpeaker(entry.contentRect.width)
      setHeightPrevSpeaker(entry.contentRect.height)

      if (onResize) {
        onResize(entry.contentRect)
      }
    },
    [onResize]
  )

  useLayoutEffect(() => {
    if (!ref.current) {
      return
    }

    const RO = new ResizeObserver(entries => handleResize(entries))
    RO.observe(ref.current)

    return () => {
      RO.disconnect()
    }
  }, [handleResize, ref])

  return { widthPrevSpeaker, heightPrevSpeaker }
}
